<div id="map-container">
    <div id="viewDiv" #mapViewNode></div>
</div>